import {
  FORMULA_EDITOR_GET_DIMENSIONS_LIST_INIT,
  FORMULA_EDITOR_GET_DIMENSIONS_LIST_SUCCESS,
  FORMULA_EDITOR_GET_DIMENSIONS_LIST_FAILURE,
  FORMULA_EDITOR_GET_METRICS_LIST_INIT,
  FORMULA_EDITOR_GET_METRICS_LIST_SUCCESS,
  FORMULA_EDITOR_GET_METRICS_LIST_FAILURE,
  FORMULA_EDITOR_GET_POLYNOMIALS_LIST_INIT,
  FORMULA_EDITOR_GET_POLYNOMIALS_LIST_SUCCESS,
  FORMULA_EDITOR_GET_POLYNOMIALS_LIST_FAILURE,  
  FORMULA_EDITOR_GET_DIMENSION_INSTANCES_SELECT_LIST_INIT,
  FORMULA_EDITOR_GET_DIMENSION_INSTANCES_SELECT_LIST_SUCCESS,
  FORMULA_EDITOR_GET_DIMENSION_INSTANCES_SELECT_LIST_FAILURE,
  FORMULA_EDITOR_SET_FORMULA_TO_EDIT_OBJECT,
  FORMULA_EDITOR_EDIT_FORMULA_TO_EDIT_OBJECT,
  FORMULA_EDITOR_EDIT_FORMULA_TO_EDIT_OBJECT_ENTITY_DATA,
  FORMULA_EDITOR_CHANGE_COLLAPSE_FORMULA_ENTITY,
  FORMULA_EDITOR_CHANGE_COLLAPSE_ALL_FORMULA_ENTITY,
  FORMULA_EDITOR_DELETE_FORMULA_ENTITY,
  FORMULA_EDITOR_FORMULA_CREATE_MARK,
  FORMULA_EDITOR_FORMULA_CUT,
  FORMULA_EDITOR_FORMULA_PASTE,
  FORMULA_EDITOR_FORMULA_VALIDATION_INIT,
  FORMULA_EDITOR_FORMULA_VALIDATION_SUCCESS,
  FORMULA_EDITOR_FORMULA_VALIDATION_FAILURE,
  FORMULA_EDITOR_FORMULA_GRAMMAR_VALIDATION_INIT,
  FORMULA_EDITOR_FORMULA_GRAMMAR_VALIDATION_SUCCESS,
  FORMULA_EDITOR_FORMULA_GRAMMAR_VALIDATION_FAILURE,
  FORMULA_EDITOR_RESET
} from './types';
import Constants from '../../../definitions/constants';
import ActionsTooling from '../../../tooling/actionsTooling';
import { intl } from '../../../locales/localesConfig';

export function reset() {
  return {
    type: FORMULA_EDITOR_RESET
  };
}

export function getDimensionsList() {
  let params = {
    mini_list_version: true, 
    order_fields: ["name"],
    order_directions: [Constants.crudGenerator.orderTypes.ASC],
    fields_are: ["active"],
    searches_are: [true],
    per_page: Constants.interface.fullListPageSize
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: FORMULA_EDITOR_GET_DIMENSIONS_LIST_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/dimension/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(FORMULA_EDITOR_GET_DIMENSIONS_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(FORMULA_EDITOR_GET_DIMENSIONS_LIST_FAILURE, error));
    }  
  };
}

export function getMetricsList() {
  let params = {
    mini_list_version: true, 
    order_fields: ["name"],
    order_directions: [Constants.crudGenerator.orderTypes.ASC],
    fields_are: ["active"],
    searches_are: [true],
    per_page: Constants.interface.fullListPageSize
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: FORMULA_EDITOR_GET_METRICS_LIST_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/metric/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(FORMULA_EDITOR_GET_METRICS_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(FORMULA_EDITOR_GET_METRICS_LIST_FAILURE, error));
    }  
  };
}

export function getPolynomialsList() {
  let params = {
    editor_list_version: true, 
    order_fields: ["name"],
    order_directions: [Constants.crudGenerator.orderTypes.ASC],
    fields_are: ["active"],
    searches_are: [true],
    per_page: Constants.interface.fullListPageSize
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: FORMULA_EDITOR_GET_POLYNOMIALS_LIST_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/polynomial/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(FORMULA_EDITOR_GET_POLYNOMIALS_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(FORMULA_EDITOR_GET_POLYNOMIALS_LIST_FAILURE, error));
    }  
  };
}

export function getDimenesionInstancesSelect(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(FORMULA_EDITOR_GET_DIMENSION_INSTANCES_SELECT_LIST_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/dimension/getdimenesioninstances",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(FORMULA_EDITOR_GET_DIMENSION_INSTANCES_SELECT_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(FORMULA_EDITOR_GET_DIMENSION_INSTANCES_SELECT_LIST_FAILURE, error));
    }  
  };
}

export function setFormulaToEditObject(formulaObject) {
  return {
    type: FORMULA_EDITOR_SET_FORMULA_TO_EDIT_OBJECT,
    formulaObject: formulaObject
  };
}

export function editFormulaToEditObject(parentId, index, position, valueToAdd, contextInfo = {}) {
  return {
    type: FORMULA_EDITOR_EDIT_FORMULA_TO_EDIT_OBJECT,
    parentId: parentId,
    index: index,
    position: position,
    valueToAdd: valueToAdd,
    contextInfo: contextInfo
  };
}

export function editFormulaToEditObjectEntityData(entityId, path, data) {
  return {
    type: FORMULA_EDITOR_EDIT_FORMULA_TO_EDIT_OBJECT_ENTITY_DATA,
    entityId: entityId,
    path: path,
    data: data
  };
}

export function changeCollapseFormulaEntity(entityId, forceOpen = false) {
  return {
    type: FORMULA_EDITOR_CHANGE_COLLAPSE_FORMULA_ENTITY,
    entityId: entityId,
    forceOpen: forceOpen
  };
}

export function changeCollapseAllFormulaEntity(collapse) {
  return {
    type: FORMULA_EDITOR_CHANGE_COLLAPSE_ALL_FORMULA_ENTITY,
    collapse: collapse
  };
}

export function deleteFormulaEntity(entityId) {
  return {
    type: FORMULA_EDITOR_DELETE_FORMULA_ENTITY,
    entityId: entityId
  };
}

export function editFormulaAddMark(segmentObject) {
  return {
    type: FORMULA_EDITOR_FORMULA_CREATE_MARK,
    segmentObject: segmentObject
  };
}

export function editFormulaCut(segmentObject) {
  return {
    type: FORMULA_EDITOR_FORMULA_CUT,
    segmentObject: segmentObject
  };
}

export function editFormulaPaste(positionObject, formulaToPaste) {
  return {
    type: FORMULA_EDITOR_FORMULA_PASTE,
    positionObject: positionObject,
    formulaToPaste: formulaToPaste
  };
}

export function formulaValidation(formulaData) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(FORMULA_EDITOR_FORMULA_VALIDATION_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/polynomial/formulavalidation",
        "POST",
        null,
        formulaData
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(FORMULA_EDITOR_FORMULA_VALIDATION_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(FORMULA_EDITOR_FORMULA_VALIDATION_FAILURE, error));
    }  
  };
}

export function formulaGrammarValidation(formulaData) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(FORMULA_EDITOR_FORMULA_GRAMMAR_VALIDATION_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/polynomial/formulagrammarvalidation",
        "POST",
        null,
        formulaData
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(FORMULA_EDITOR_FORMULA_GRAMMAR_VALIDATION_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(FORMULA_EDITOR_FORMULA_GRAMMAR_VALIDATION_FAILURE, error));
    }  
  };
}



// WEBPACK FOOTER //
// ./source/client/actions/formulaEditor/index.js